import React from "react";
import { Layout, Typography, Row, Col, Card, Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const benefits = [
  {
    title: "Hands-on Learning",
    description: "Engage in real-world AI, Cybersecurity, and Data Science projects and challenges.",
  },
  {
    title: "Industry Mentorship",
    description: "Get guidance from top professionals to accelerate your learning and career.",
  },
  {
    title: "Certifications & Assessments",
    description: "Earn industry-recognized certifications to showcase your expertise.",
  },
  {
    title: "Career Opportunities",
    description: "Access exclusive internship and job listings in the tech ecosystem.",
  },
  {
    title: "Networking & Collaboration",
    description: "Join a thriving community of learners, mentors, and industry leaders.",
  },
  {
    title: "AI-Driven Personalized Learning",
    description: "Leverage AI to receive customized learning recommendations tailored to your needs.",
  },
];

const WhyJoinJectHub = () => {
  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5", textAlign: "center" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          Why Join JectHub?
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "30px" }}>
          JectHub empowers students and professionals to bridge the gap between theory and practical experience in AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} justify="center">
          {benefits.map((benefit, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                hoverable
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "16px",
                }}
              >
                <CheckCircleOutlined style={{ fontSize: "40px", color: "#1890ff", marginBottom: "16px" }} />
                <Title level={4} style={{ color: "#333", marginBottom: "12px" }}>
                  {benefit.title}
                </Title>
                <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                  {benefit.description}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>

        <Button
          type="primary"
          size="large"
          href="/signin"
          style={{ marginTop: "40px", backgroundColor: "#1890ff", borderColor: "#1890ff" }}
        >
          Join Now
        </Button>
      </Content>
    </Layout>
  );
};

export default WhyJoinJectHub;